module.exports = "//static.hsappstatic.net/salesImages/static-1.403/logos/hubspot-logo-for-dark-transparent-2x.png"